module.exports = __webpack_public_path__ + "img/results_off.6fe51287.svg";